<template>
  <binds-dialog v-bind="$attrs" v-on="$listeners" :binds-fullscreen="false">
    <binds-dialog-title v-if="bindsTitle">{{ bindsTitle }}</binds-dialog-title>
    <binds-dialog-content v-if="bindsContent" v-html="bindsContent" />

    <binds-dialog-actions>
      <binds-button class="binds-primary" @click="$emit('update:bindsActive', false)">{{ bindsConfirmText }}</binds-button>
    </binds-dialog-actions>
  </binds-dialog>
</template>

<script>
export default {
  name: 'BindsDialogAlert',
  props: {
    bindsTitle: String,
    bindsContent: String,
    bindsConfirmText: {
      type: String,
      default: 'Ok'
    }
  }
}
</script>
